export const API_URL = import.meta.env.VITE_API_URL;
export const S3_URL = import.meta.env.VITE_S3_IMAGE_BASE_URL;
export const GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
